export const TEXT_KEYS = {
    APP_TITLE_TEXT: 'app-title',
    GAME_NAME: 'gameName'
};
